const OTP_RATE_LIMIT_KEY_SAKHAD = "lastOtpTimestampSakhad";
const OTP_RATE_LIMIT_DURATION_SAKHAD = 3 * 60 * 1000; // 2 دقیقه

export const canSendOtpSakhad = () => {
  const lastTime = localStorage.getItem(OTP_RATE_LIMIT_KEY_SAKHAD);
  const now = Date.now();
  if (!lastTime) {
    return { allowed: true, remaining: 0, remainingFormatted: "00:00" };
  }

  const elapsed = now - Number(lastTime);
  const remaining = OTP_RATE_LIMIT_DURATION_SAKHAD - elapsed;

  if (remaining <= 0) {
    return { allowed: true, remaining: 0, remainingFormatted: "00:00" };
  }

  const totalSeconds = Math.ceil(remaining / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const formatted = `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;

  return {
    allowed: false,
    remaining: totalSeconds,
    remainingFormatted: formatted,
  };
};

export const markSakhadOtpSent = () => {
  localStorage.setItem(OTP_RATE_LIMIT_KEY_SAKHAD, Date.now().toString());
};
